import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_344: DocMigration = {
  maxSchemaVersion: "0.0.344",
  description: "Set parentId for elevation view annotations previously derived by referenceFrame",
  apply(json: any) {
    for (const id in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[id];
      if (viewTemplate.viewType === "ELEVATION_VIEW") {
        const annotationIndex = viewTemplate.categories.indexOf("ANNOTATION");
        if (annotationIndex !== -1) {
          viewTemplate.categories.splice(annotationIndex + 1, 0, "ELEVATION_MARKERS", "MATERIAL_TAGS", "GRADE_LINE");
        }
      }
    }
    return json;
  },
};

export default migration_0_0_344;
